var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skill",attrs:{"title":_vm.title},on:{"click":function($event){_vm.goToURL()}}},[_c('p',[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]),_vm._v(" "),_c('progress',{attrs:{"max":"10"},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }